/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SoftDatePicker from "components/SoftDatePicker";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Footer from "./footer";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
  fontSize: "14px"
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontWeight: row.bold ? "bold" : 400 }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    bold: false,
    id: {
      value: 1,
      bg: false,
    },
    contractorsName: {
      value: "",
      bg: false,
    },
    careerName: {
      value: "",
      bg: false,
    },
    taxId: {
      value: "",
      bg: false,
    },
    number: {
      value: "",
      bg: false,
    },
    date: {
      value: "",
      bg: false,
    },
    revenue: {
      value: 0,
      bg: false,
    },
    paymentDate: {
      value: "",
      bg: false,
    },
    revenueGTGT: {
      value: 0,
      bg: false,
    },
    percentGTGT: {
      value: "0.00",
      bg: false,
    },
    revenueTNDN: {
      value: 0,
      bg: false,
    },
    percentTNDN: {
      value: "0.00",
      bg: false,
    },
    exemptionsTax: {
      value: 0,
      bg: false,
    },
  },
];

export default function TaxPersonalTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;

    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const getMaxIdValue = () => {
    return Math.max(...data.map((item) => item.id.value), 0);
  };

  const addNewRow = () => {
    const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      bold: false,
      id: {
        value: newIdValue,
        bg: false,
      },
      contractorsName: {
        value: "",
        bg: false,
      },
      careerName: {
        value: "",
        bg: false,
      },
      taxId: {
        value: "",
        bg: false,
      },
      number: {
        value: "",
        bg: false,
      },
      date: {
        value: "",
        bg: false,
      },
      revenue: {
        value: 0,
        bg: false,
      },
      paymentDate: {
        value: "",
        bg: false,
      },
      revenueGTGT: {
        value: 0,
        bg: false,
      },
      percentGTGT: {
        value: "0.00",
        bg: false,
      },
      revenueTNDN: {
        value: 0,
        bg: false,
      },
      percentTNDN: {
        value: "0.00",
        bg: false,
      },
      exemptionsTax: {
        value: 0,
        bg: false,
      },
    };

    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };


  return (
    <Box display="flex" flexDirection="column" mt={5}
    >
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
      <Box style={{ maxWidth: '100%', overflowX: 'auto' }}>
        <table style={tableStyle}>
          <thead style={{background: "#eaeae9"}}>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} colSpan="2">
                Nội dung
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} rowSpan="2">
                Mã số thuế của NTNN Việt Nam (nếu có)
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} colSpan="2">
                Hợp đồng
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} rowSpan="2">
                Doanh thu chưa bao gồm thuế GTGT
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} rowSpan="2">
                Ngày thanh toán
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} colSpan="3">
                Thuế giá trị gia tăng (GTGT)
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} colSpan="4">
                Thuế thu nhập doanh nghiệp (TNDN)
              </Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }} rowSpan="2">
                Tổng số thuế phải nộp vào Ngân sách Nhà nước
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Tên nhà thầu</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Tên ngành nghề</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Số</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Ngày /tháng /năm</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Doanh thu tính thuế</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Tỷ lệ % để tính thuế GTGT</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Thuế giá trị gia tăng phải nộp</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Doanh thu tính thuế</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Tỷ lệ (%) thuế TNDN</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Số thuế được miễn giảm theo Hiệp định</Th>
              <Th style={{ textAlign: "center", fontWeight: "bold"  }}>Thuế thu nhập doanh nghiệp phải nộp</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(1a)</Th>
              <Th style={{ textAlign: "center" }}>(1b)</Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }}>(6)</Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9=8x7)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)</Th>
              <Th style={{ textAlign: "center" }}>[13=(10x11)-12]</Th>
              <Th style={{ textAlign: "center" }}>(14=(9)+(13))</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value}>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {row.id.value}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "center",
                      background: !row.contractorsName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.contractorsName.bg ? (
                      row.contractorsName.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="contractorsName"
                        value={row.contractorsName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      background: !row.careerName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.careerName.bg ? (
                      row.careerName.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="careerName"
                        value={row.careerName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      background: !row.taxId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxId.bg ? (
                      row.taxId.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="taxId"
                        value={row.taxId.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.number.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.number.bg ? (
                      row.number.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="number"
                        value={row.number.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.date.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.date.bg ? (
                      row.date.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="date"
                        value={row.date.value}
                        onChange={handleChange}
                        type="date"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenue.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenue.bg ? (
                      row.revenue.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="revenue"
                        value={row.revenue.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.paymentDate.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.paymentDate.bg ? (
                      row.paymentDate.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="paymentDate"
                        value={row.paymentDate.value}
                        onChange={handleChange}
                        type="date"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenueGTGT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenueGTGT.bg ? (
                      row.revenueGTGT.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="revenueGTGT"
                        value={row.revenueGTGT.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.percentGTGT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.percentGTGT.bg ? (
                      row.percentGTGT.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="percentGTGT"
                        value={row.percentGTGT.value}
                        onChange={handleChange}
                        type="decimal"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: "#ddeff3",
                    }}
                  >
                    {Math.round(row.percentGTGT.value * row.revenueGTGT.value)}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.revenueTNDN.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.revenueTNDN.bg ? (
                      row.revenueTNDN.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="revenueTNDN"
                        value={row.revenueTNDN.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.percentTNDN.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.percentTNDN.bg ? (
                      row.percentTNDN.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="percentTNDN"
                        value={row.percentTNDN.value}
                        onChange={handleChange}
                        type="decimal"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.exemptionsTax.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.exemptionsTax.bg ? (
                      row.exemptionsTax.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="exemptionsTax"
                        value={row.exemptionsTax.value}
                        onChange={handleChange}
                        type="number"
                      />
                    )}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: "#ddeff3",
                    }}
                  >
                    {Math.round(row.percentTNDN.value * row.revenueTNDN.value - row.exemptionsTax.value)}
                  </Td>
                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: "#ddeff3",
                    }}
                  >
                    {Math.round(row.percentTNDN.value * row.revenueTNDN.value -
                      row.exemptionsTax.value +
                      row.percentGTGT.value * row.revenueGTGT.value)}
                  </Td>
                </tr>
              ))}
            <tr>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                Tổng cộng:
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {data.reduce((total, item) => total + (item.revenue.value | 0), 0)}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {data.reduce((total, item) => total + (item.revenueGTGT.value | 0), 0)}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {Math.round(data.reduce(
                  (total, item) => total + (item.revenueGTGT.value * item.percentGTGT.value),
                  0
                ))}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {data.reduce((total, item) => total + (item.revenueTNDN.value | 0), 0)}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {data.reduce((total, item) => total + (item.exemptionsTax.value | 0), 0)}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {Math.round(Math.round(data.reduce(
                  (total, item) =>
                    total +
                    (item.revenueTNDN.value * item.percentTNDN.value) -
                    item.exemptionsTax.value,
                  0
                )))}
              </Td>
              <Td
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                {Math.round(data.reduce(
                  (total, item) =>
                    total +
                    ((item.revenueTNDN.value * item.percentTNDN.value) -
                      item.exemptionsTax.value +
                      (item.revenueGTGT.value * item.percentGTGT.value)),
                  0
                ))}
              </Td>
            </tr>
          </tbody>
        </table>
        </Box>

        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  const regexDecimal = /^(0|0?\.\d*|1|1(\.0*)?)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name });
    }
  }
  return (
    <input
      type={type == "date" ? "date" : ""}
      style={{
        textAlign: type == "number" || type == "decimal" ? "right" : "left",
        fontSize: 14,
        color: "#344767",
        border: "none",
        width: type == "date" ? "150px" : "100px",
        background: "transparent",
        padding: "4px 4px 4px 4px",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
